import { mensagemCampoObrigatorio, mensagemMinimo3Caracteres } from '@core/util/mensagemUtil';
import * as Yup from 'yup';

export const useUsuarioValidation = () => {
  return Yup.object().shape({
    nome: Yup.string()
      .nullable()
      .required(mensagemCampoObrigatorio('o nome'))
      .min(3, mensagemMinimo3Caracteres),
    email: Yup.string()
      .nullable()
      .email('E-mail é inválido')
      .required(mensagemCampoObrigatorio('o e-mail')),
    grupoAcesso: Yup.object()
      .shape({
        id: Yup.string()
          .nullable()
          .required(mensagemCampoObrigatorio('o grupo de acesso')),
      })
      .nullable()
      .required(mensagemCampoObrigatorio('o grupo de acesso')),
    vendedor: Yup.object()
      .nullable()
      // Arrow function não é possível acessar o this.parent, sempre declarar function comum
      .test('vendedor', mensagemCampoObrigatorio('o nome do vendedor'), function(vendedor) {
        return !this.parent.bindVendedor || !!vendedor?.id;
      }),
    selectedEmpresa: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string()
            .nullable()
            .required(mensagemCampoObrigatorio('uma empresa')),
        })
      )
      .test('selectedEmpresa', mensagemCampoObrigatorio('uma empresa'), function(selectedEmpresa) {
        if (this.parent?.empresas?.length > 0) {
          return true;
        }
        return false;
      }),
    periodoAcessoInicio: Yup.string()
      .nullable()
      // Arrow function não é possível acessar o this.parent, sempre declarar function comum
      .test('periodoAcessoInicio', mensagemCampoObrigatorio('o período de acesso'), function() {
        return !this.parent.restricoes?.configurarPeriodo || !!this.parent.restricoes?.periodoAcessoInicio;
      }),
  });
};
